// Qué decirle a quien abre la bandeja cuando el listado falla, y si tiene sentido reintentar.
//
// El silo tipa el motivo en el `code`. Un PERMISSION_DENIED no cambia por insistir, así que ni lo
// ofrece ni promete que se va a arreglar.
import { ApiError } from '@/api/errors';

export interface KycPendingErrorCopy {
    title: string;
    description: string;
    /** Si es falso no se pinta el botón Reintentar: insistir no cambia el resultado. */
    canRetry: boolean;
}

export function kycPendingErrorCopy(error: Error): KycPendingErrorCopy {
    const code = error instanceof ApiError ? error.code : null;
    switch (code) {
        case 'PERMISSION_DENIED':
            return {
                title: 'No tienes permiso para ver los KYC pendientes',
                description:
                    'Esta bandeja es de Cumplimiento y tu rol no la incluye. Si crees que es un error, contacta a quien administra los roles.',
                canRetry: false,
            };
        default:
            return {
                title: 'No se pudieron cargar los KYC pendientes',
                description: error.message,
                canRetry: true,
            };
    }
}
